const initialState = {
  contact: null,
};

const formContact = (state = initialState, action) => {
  switch (action.type) {
    case 'SET_FORM_CONTACT':
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};

export default formContact;
